import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@components/Image'
import { ElementHTML, getBackgroundColor } from '@helpers/helper.rendering'
const Services3 = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    items,
    backgroundColor,
    subtitleElement,
    titleElement,
    paragraphColor,
    backgroundHexa,
    paragraphHexa,
    itemIndexElement,
    titleColor,
    titleHexa,
    customFontSize
  } = props

  const isDesktop = () => typeof window !== 'undefined' && (screen?.width < 992 ? false : true)

  return (
    <section
      id="bio"
      className={`${backgroundColor} ${paragraphColor} p-y-config`}
      style={{
        backgroundColor: backgroundColor === 'background-picker' ? backgroundHexa : '',
        color: paragraphColor === 'text-picker' ? paragraphHexa : '',
      }}
    >
      <Container
        fluid
        style={{ maxWidth: '100%' }}
      >
        <div className="pt-0 pb-3">
          {title ? (
            <Col xs={12}>
              <ElementHTML
                children={title}
                elementType={titleElement ?? 'h2'}
                className={`my-5 text-center ${titleColor}`}
                style={{
                  color: titleColor === 'text-picker' ? titleHexa : '',
                }}
              />
            </Col>
          ) : null}
        </div>
        {items && items?.length > 0
          ? items?.map((item, i) => (
              <Row
                key={i}
                className="align-items-stretch my-3 justify-content-center"
              >
                <Col
                  xs={12}
                  lg={5}
                  className={`
                  ${
                    item?.align && item?.align === 'left'
                      ? 'order-1 order-lg-2 ps-0 d-flex justify-content-end align-items-center'
                      : 'order-1 pe-0 d-flex justify-content-end align-items-center'
                  } p-lg-4 me-lg-1`}
                >
                  {item?.hrefVideo ? (
                    <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' }}>
                      <iframe
                        className="position-absolute top-0 left-0"
                        width="100%"
                        height="100%"
                        src={
                          'https://youtube.com/embed/' +
                          (isDesktop()
                            ? item?.hrefVideo
                            : item?.hrefVideoMobile ?? item?.hrefVideo) +
                          '?autoplay=1&mute=1&loop=1&controls=0&rel=0&showinfo=0&playlist=' +
                          (isDesktop() ? item?.hrefVideo : item?.hrefVideoMobile ?? item?.hrefVideo)
                        }
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        style={{ pointerEvents: 'none', border: 0 }}
                      />
                    </div>
                  ) : item?.image && item?.isAnimatedImage ? (
                    <img
                      className="item-img no-border w-100 h-100"
                      style={{ objectFit: 'cover' }}
                      alt={item?.title ?? ''}
                      src={item.image}
                    />
                  ) : (
                    item?.image_gatsby && (
                      <Image
                        className="item-img no-border w-100 h-100"
                        objectFit="cover"
                        alt={item?.title ?? ''}
                        image={item.image_gatsby}
                      />
                    )
                  )}
                </Col>
                <Col
                  xs={12}
                  lg={5}
                  className={`p-lg-4 ms-lg-1 d-flex align-items-start flex-column ${
                    item?.align === 'left' ? 'order-1 order-lg-1' : 'order-1 order-lg-2'
                  }`}
                >
                  <Container className={`mt-lg-auto mt-5 mb-lg-auto mb-0 ${paragraphColor}`}>
                    <ElementHTML
                      children={item?.itemIndex ?? ''}
                      elementType={itemIndexElement ?? 'h1'}
                      style={{
                        color: paragraphColor === 'text-picker' ? paragraphHexa : '',
                        ...(customFontSize ? { fontSize: `${customFontSize}rem` } : {}),
                      }}
                      className={`${paragraphColor} text-start`}
                    />
                    <div className="d-lg-block title-wrapper pb-4 text-start">
                      <ElementHTML
                        className={'mt-4 ' + paragraphColor}
                        children={item?.subtitle ?? ''}
                        elementType={subtitleElement ?? 'h2'}
                        style={{
                          color: paragraphColor === 'text-picker' ? paragraphHexa : '',
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: '35%',
                        height: '1px',
                        backgroundColor: getBackgroundColor(
                          paragraphColor ?? 'text-primary',
                          paragraphHexa ?? '#000',
                        ),
                        marginBottom: '1rem ',
                      }}
                    />
                    {item?.paragraph && item?.paragraph?.length > 0 ? (
                      <p
                        className={'my-3 text-content text-start ' + paragraphColor}
                        key={i}
                        style={{
                          color: paragraphColor === 'text-picker' ? paragraphHexa : '',
                        }}
                      >
                        {item?.paragraph}
                      </p>
                    ) : null}
                  </Container>
                </Col>
              </Row>
            ))
          : null}
      </Container>
    </section>
  )
}

export default Services3
